import { usePost } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useAddCandidate = () => {
  return usePost({ url: ApiRoutesEnum.addCandidate });
};
